import { IDropdownItemProps } from './types'
import styles from './styles.module.scss'
import clsx from 'clsx'

const DropdownItem = ({
  icon,
  id,
  isDisabled = false,
  isSelected = false,
  onClick,
  size = 'md',
  subtitle,
  title,
}: IDropdownItemProps) => {
  return (
    <div
      className={clsx('mui-dropdown-item', styles[`item${size}`], {
        [styles.selected]: isSelected,
        [styles.disabled]: isDisabled,
        [styles.noSubtitle]: !subtitle,
      })}
      onClick={onClick ? () => onClick(id) : undefined}
      role={onClick ? 'button' : 'presentation'}
    >
      <span className={styles.icon}>{icon}</span>
      <span className={styles.titleAndSub}>
        <p className={styles.title}>{title}</p>
        {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
      </span>
    </div>
  )
}

export default DropdownItem
